import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../services/utilService/util.service";
import {SuperAdminService} from "../../services/apiCalls/superAdminService/super-admin.service";
import {IResponse} from "../../interfaces/iresponse";

@Component({
  selector: 'app-supported-banks',
  templateUrl: './supported-banks.component.html',
  styleUrls: ['./supported-banks.component.css']
})
export class SupportedBanksComponent implements OnInit {
  breadCrumb: any;
  public banks: any[] = [];
  loadingData = false;
  constructor(private utilService: UtilService,
              private superAdminService: SuperAdminService) { }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Supported Banks',
      parent: 'Settings',
      subLink: null
    };
    this.getBanks();
  }

  getBanks() {
    this.loadingData = true;
    this.superAdminService.getBanks()
      .subscribe((res: IResponse) => {
        console.log('Response ', res);
        const banks = res.data;
        this.banks = banks.sort(
          function(a, b) {
            const textA = a.bank_name.toUpperCase();
            const textB = b.bank_name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          }
        );
        this.utilService.riderTable('all-banks', false);
        this.loadingData = false;
      }, error => {
        console.log('Error ', error);
        this.utilService.startDatatable('all-banks');
        this.loadingData = false;
      });
  }

}
